import { Example } from "../models/ExampleModel";
import { ExplanationModel } from "../models/ExplanationModel";
import { ConjugationTableData } from "../models/table-models/ConjugationTableDataModel";

export const futuroPerfectoExplanation: ExplanationModel = {
    title: "📖 What is Futuro Perfecto?",
    description: `
The Futuro Perfecto (Future Perfect) is used to express actions that will have been completed by a certain point in the future.
`.trim(),
    bulletPoints: [
        "To express an action that will have been completed at a future moment.",
        "➝ 'Para mañana, habré comido.' (By tomorrow, I will have eaten.)",
        "To show probability or assumption about the past.",
        "➝ '¿Dónde está Juan? → Habrá salido.' (Where is Juan? → He must have left.)"
    ],
    examples: [
        "📌 Structure: Future Simple of Haber + Past Participle of the verb."
    ]
};

export const futuroPerfectoExamples: Example[] = [
    {
        sentence: "Para el lunes, habré terminado el proyecto.",
        explanation: "📅 Future Completion – 'By Monday, I will have finished the project.' This sentence shows an action that will be completed by a specific future moment."
    },
    {
        sentence: "Para el final del año, habremos visitado todos los países.",
        explanation: "🌍 Future Achievement – 'By the end of the year, we will have visited all the countries.' It expresses an accomplishment by a set future deadline."
    },
    {
        sentence: "¿Habrá llegado ya Pedro?",
        explanation: "🤔 Probability – 'Will Pedro have arrived already?' This sentence expresses uncertainty and speculation about the past."
    },
    {
        sentence: "Para la próxima semana, habré aprendido todo.",
        explanation: "📖 Future Expectation – 'By next week, I will have learned everything.' This expresses confidence in completing an action before a specific future point."
    },
    {
        sentence: "Cuando llegues, habrán salido.",
        explanation: "🚪 Sequential Action – 'When you arrive, they will have left.' This sentence shows a completed action before another future event."
    }
];

export const futuroPerfectoRegular: ConjugationTableData = {
    title: "Regular Verbs",
    verbs: [
        {
            verb: "Hablar",
            conjugations: [
                "habré hablado", "habrás hablado", "habrá hablado",
                "habremos hablado", "habréis hablado", "habrán hablado"
            ]
        },
        {
            verb: "Comer",
            conjugations: [
                "habré comido", "habrás comido", "habrá comido",
                "habremos comido", "habréis comido", "habrán comido"
            ]
        },
        {
            verb: "Vivir",
            conjugations: [
                "habré vivido", "habrás vivido", "habrá vivido",
                "habremos vivido", "habréis vivido", "habrán vivido"
            ]
        }
    ]
};

export const futuroPerfectoIrregular: ConjugationTableData = {
    title: "Irregular Verbs",
    verbs: [
        {
            verb: "Tener",
            conjugations: [
                "habré tenido", "habrás tenido", "habrá tenido",
                "habremos tenido", "habréis tenido", "habrán tenido"
            ]
        },
        {
            verb: "Hacer",
            conjugations: [
                "habré hecho", "habrás hecho", "habrá hecho",
                "habremos hecho", "habréis hecho", "habrán hecho"
            ]
        },
        {
            verb: "Decir",
            conjugations: [
                "habré dicho", "habrás dicho", "habrá dicho",
                "habremos dicho", "habréis dicho", "habrán dicho"
            ]
        },
        {
            verb: "Poner",
            conjugations: [
                "habré puesto", "habrás puesto", "habrá puesto",
                "habremos puesto", "habréis puesto", "habrán puesto"
            ]
        },
        {
            verb: "Salir",
            conjugations: [
                "habré salido", "habrás salido", "habrá salido",
                "habremos salido", "habréis salido", "habrán salido"
            ]
        },
        {
            verb: "Poder",
            conjugations: [
                "habré podido", "habrás podido", "habrá podido",
                "habremos podido", "habréis podido", "habrán podido"
            ]
        },
        {
            verb: "Saber",
            conjugations: [
                "habré sabido", "habrás sabido", "habrá sabido",
                "habremos sabido", "habréis sabido", "habrán sabido"
            ]
        },
        {
            verb: "Haber",
            conjugations: [
                "habré habido", "habrás habido", "habrá habido",
                "habremos habido", "habréis habido", "habrán habido"
            ]
        }
    ]
};